import { render, staticRenderFns } from "./EllipsisVIcon.vue?vue&type=template&id=8ea3693c&"
import script from "./EllipsisVIcon.vue?vue&type=script&lang=js&"
export * from "./EllipsisVIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports